import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TourMatMenu } from 'ngx-ui-tour-md-menu';
import { InfoIconComponent } from 'src/app/shared/info-icon/info-icon.component';
import { PortfolioSummaryComponent } from 'src/app/shared/portfolio-summary/portfolio-summary.component';
import { SortByPipe } from 'src/app/pipes/sortBy.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PortfolioHierarchy } from 'src/app/models/classes/investor-dashboard.class';
import { InvestorMeta } from 'src/app/models/classes/investor-meta.class';

@Component({
  selector: 'app-investor-portfolio-summary',
  imports: [
    InfoIconComponent,
    PortfolioSummaryComponent,
    SortByPipe,
    RouterModule,
    MatTooltipModule,
    TourMatMenu
],
  templateUrl: './investor-portfolio-summary.component.html',
  styleUrls: ['./investor-portfolio-summary.component.scss']
})
export class InvestorPortfolioSummaryComponent {
  readonly activeInvestorMetadata = input.required<InvestorMeta>();
  readonly investorPortfolioData = input.required<PortfolioHierarchy[]>();
  readonly iconSet = input<Record<string, string> | undefined>(undefined);

  readonly selectedAsOfDate = input<string>('');
  investorPortfolios = computed<PortfolioHierarchy[]>(() => {
    const iconSet = this.iconSet();
    const portfolios = this.investorPortfolioData();
    if (iconSet && portfolios) {
      return portfolios?.sort((a, b) => a.ticker.localeCompare(b.ticker));
    }
    return [];
  });
}
